<template>
  <div class="invoice-booking" :class="`state-${bookingState}`">
    <div class="invoice-header">
      <div class="booking-number">
        {{$t('profile.invoice.booking')}} <span>#{{bookingId}}</span>
      </div>
      <div class="booking-state">
        {{$t('profile.invoice.state.' + bookingState)}}
      </div>
      <div class="booking-invoices">
        <template v-if="!hasInvoices">
          <span class="not-allowed">
            <cloud-download-svg :disabled="true" />
          </span>
        </template>
        <template v-else>
          <a :href="invoiceLink" target="_blank">
            <cloud-download-svg />
          </a>
        </template>
      </div>
    </div>
    <div class="invoice-rooms">
      <invoice-room v-for="(room, index) in rooms" :key="room.id" :index="index" :room="room" />
    </div>
  </div>
</template>

<script>
import CloudDownloadSvg from "../../../../components/svg/cloud-download-svg";
import InvoiceRoom from "./invoice-room";
export default {
  name: "invoice-booking",
  components: {InvoiceRoom, CloudDownloadSvg},
  computed: {
    rooms() {
      return this.booking.rooms;
    },
    bookingId() {
      return this.booking.id
    },
    bookingState() {
      if (!this.booking.is_paid) return 'waiting';
      if (this.booking.is_refund) return 'refunded';
      if (this.booking.is_deleted) return 'deleted';
      return 'paid';
    },
    hasInvoices() {
      return this.booking.invoices.length > 0;
    },
    invoiceLink() {
      return this.booking.invoices.length > 0 ? this.booking.invoices[0].link : null
    }
  },
  props: {
    booking: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/client/part/order-history/invoice-booking.vue